import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../hooks/useLanguage';

function Navbar() {
  const { t } = useTranslation();
  const { changeLanguage, isCurrentLanguage } = useLanguage();

  const NAV_LINKS = [
    { label: t('navigation.home'), href: '/' },
    { label: t('navigation.project'), href: '/innerpages/portfolio' },
    { label: t('navigation.about'), href: '/home7_landscape/' },
    { label: t('navigation.contact'), href: '/innerpages/contact' },
  ];

  const LANGUAGE_SWITCH = [
    { label: t('language.en'), code: 'en' },
    { label: t('language.bg'), code: 'bg' },
  ];

  return (
    <nav className="navbar navbar-expand-lg navbar-dark tc-navbar-style1 section-padding-x">
      <div className="container-fluid content">
        <a className="navbar-brand" href="/">
          <img src="/home1/assets/img/logo_light.png" alt="Logo" className="logo d-none d-sm-block" />
          <img src="/home1/assets/img/logo_dark.png" alt="Mobile Logo" className="logo d-block d-sm-none" />
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0" style={{ width: '100%' }}>
            {NAV_LINKS.map((link, index) => (
              <li className="nav-item" key={index}>
                <a
                  className={`nav-link${window.location.pathname === link.href ? ' active' : ''}`}
                  href={link.href}
                  style={{ padding: '10px 20px', fontWeight: 500 }}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>

          <div className="nav-side d-flex align-items-center">
            {LANGUAGE_SWITCH.map((lang, index) => (
              <a 
                href="#" 
                className={`icon ms-3 ${isCurrentLanguage(lang.code) ? 'active' : ''}`} 
                key={index}
                onClick={(e) => {
                  e.preventDefault();
                  changeLanguage(lang.code);
                }}
                style={{
                  opacity: isCurrentLanguage(lang.code) ? 1 : 0.7,
                  fontWeight: isCurrentLanguage(lang.code) ? 'bold' : 'normal'
                }}
              >
                <span>{lang.label}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
